import { IUserRoles } from 'models';
import { AllCompletedWorks, CompletedWork, CompleteWorkForm, Login, MoversSalary, MyWorks, Prices, Schedule, Search, Users } from 'pages';
import { SalesSalary } from 'pages/SalesSalary';
import { RouteObject } from 'react-router';

import {
	ALL_WORKS_ROUTE,
	COMPLETED_WORK_ROUTE,
	LOGIN,
	MOVERS_SALARY_ROUTE,
	MY_WORKS_ROUTE,
	PRICES_ROUTE,
	SALES_SALARY_ROUTE,
	SCHEDULE_ROUTE,
	SEARCH_ROUTE,
	SINGLE_WORK_ROUTE,
	USERS_ROUTE
} from './consts';

const helperRoutes: RouteObject[] = [
	{
		path: MOVERS_SALARY_ROUTE,
		element: <MoversSalary />
	},
	{
		path: MY_WORKS_ROUTE,
		element: <MyWorks />
	}
];

const foremanRoutes: RouteObject[] = [
	{
		path: SINGLE_WORK_ROUTE,
		element: <CompleteWorkForm />
	},
	{
		path: SCHEDULE_ROUTE,
		element: <Schedule />
	}
];

const managerRoutes: RouteObject[] = [
	{
		path: ALL_WORKS_ROUTE,
		element: <AllCompletedWorks />
	},
	{
		path: COMPLETED_WORK_ROUTE,
		element: <CompletedWork />
	},
	{
		path: SEARCH_ROUTE,
		element: <Search />
	}
];

const adminRoutes: RouteObject[] = [
	{
		path: PRICES_ROUTE,
		element: <Prices />
	},
	{
		path: USERS_ROUTE,
		element: <Users />
	},
	{
		path: SALES_SALARY_ROUTE,
		element: <SalesSalary />
	}
];

export const publicRoutes: RouteObject[] = [
	{
		path: LOGIN,
		element: <Login />
	}
];

export const privateRoutes = (user_role: IUserRoles) => {
	let routes = [...helperRoutes];
	if (user_role !== IUserRoles.HELPER) {
		routes.push(...foremanRoutes);
	}
	if (user_role === IUserRoles.MANAGER || user_role === IUserRoles.ADMIN) {
		routes.push(...managerRoutes);
	}
	if(user_role === IUserRoles.ADMIN) {
		routes.push(...adminRoutes);
	}
	return routes;
};